import React from 'react'
import {
  CONTENT_TYPE,
  IInteractiveCard as IContentfulInteractiveCard,
} from 'marketing-site/@types/generated/contentful'
import {
  InteractiveCard,
  IProps as IImage,
} from 'marketing-site/src/mvp/library/elements/InteractiveCard'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { CTATheme } from 'marketing-site/src/library/utils/constants/themes-legacy'

export const ContentfulInteractiveCard = (card: IContentfulInteractiveCard): React.ReactElement => {
  return (
    <EntryMarker entry={card}>
      {() => <InteractiveCard {...transformInteractiveCard(card)} />}
    </EntryMarker>
  )
}

const transformCTA = (cta: IContentfulInteractiveCard['fields']['cta']) => {
  if (!cta) return
  const contentTypeId = cta?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, {
    ...cta,
    fields: {
      ...cta.fields,
      color: CTATheme.LinkOnlyBlack,
    },
  })
}

const transformImage = (image: IContentfulInteractiveCard['fields']['image']) => {
  if (!image) return
  const contentTypeId = image?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, image)
}

export function transformInteractiveCard({ fields }: IContentfulInteractiveCard): IImage {
  return {
    ...fields,
    title: fields.title,
    image: transformImage(fields.image),
    cta: fields.cta && transformCTA(fields.cta),
    ctaUrl: fields.cta && fields.cta.fields.url,
  }
}
